export const types = {
  set: 'SET_DIALOG',
  unset: 'UNSET_DIALOG'
} as const

export function setDialog(
  title: string,
  content: string,
  okHandler: () => void | Promise<void>,
  ngHandler: () => void | Promise<void>,
  noCancel?: boolean
) {
  return {
    type: types.set,
    payload: {
      title: title,
      content: content,
      okHandler: okHandler,
      ngHandler: ngHandler,
      noCancel: noCancel || false
    }
  }
}
export function unsetDialog() {
  return { type: types.unset }
}
